import { createContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";

import ProfileCompleteModal from "./ProfileCompleteModal";
import WaiverAgreementPopup from "./WaiverAgreementPopup";
import { useAuth } from "../services/wp.auth.service";

import { shouldAttendeeAgreeToTOU, shouldAttendeeCompleteDemo } from "../helpers/attendeeHelpers";

const ProfileCompleteContext = createContext(null);

export const ProfileCompleteProvider = ({ children }) => {
	const { user } = useAuth();
	const [cookies] = useCookies();

	const demoFormOpen = useMemo(
		() => shouldAttendeeCompleteDemo(user, cookies),
		[user]
	);

	const termsPopupOpen = useMemo(
		() => shouldAttendeeAgreeToTOU(user, cookies),
		[user?.accountStatus?.termsAgreedTs]
	);

	return (
		<ProfileCompleteContext.Provider value={null}>
			{children}
			<ProfileCompleteModal show={demoFormOpen} />
			<WaiverAgreementPopup show={termsPopupOpen} />
		</ProfileCompleteContext.Provider>
	);
};

ProfileCompleteProvider.propTypes = {
	children: PropTypes.oneOfType([PropTypes.shape(), PropTypes.arrayOf(PropTypes.element)]).isRequired
};
